import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';

import * as Routes from '../../constants/routes';

class GetUserOrderRequest extends baseRequest {

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.payload  = null;
        this.name     = 'get list of user orders';
        this.Config   = new AppConfig();
    }

    execute(dispatch, payload) {
        this.payload  = payload;
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.getDetailedUserOrder, payload);
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        this.dispatch(Actions.setUserOrder(this.response.data));
    }

    onFailure(){
        window.location.replace(Routes.home);
    }
}


export default GetUserOrderRequest;